/* eslint-disable menti-react/filename-convention--jsx */
'use client';

import { useDevMetricsInitializer } from '../hooks/use-dev-metrics-initializer';

export function DevMetricsInitializer({
  application,
  verbose = false,
}: {
  application: string;
  verbose?: boolean;
}) {
  useDevMetricsInitializer(application, verbose);
  return null;
}
